<div class="container-fluid">
  <div class="row">
    <!-- Centre Filter: replaced MatSelect with shared searchable-select (single select) -->
    <div class="col-3">
      <app-searchable-select
        [options]="centresWithAll$ | async"
        displayKey="centreName"
        valueKey="centreCode"
        [multiple]="true"
        [hideSelectAllOption]="false"
        placeholder="Enter Centre Name"
        label="Select Centre"
        [selectedValue]="selectedCentreObjects"
        (selectionChange)="onCentreSelected($event)">
      </app-searchable-select>
    </div>
    <!-- Year Filter -->
    <mat-form-field appearance="outline" class="col-2">
      <mat-label>Select Year</mat-label>
      <mat-select [(ngModel)]="selectedYear">
        <mat-option *ngFor="let y of years" [value]="y">
          {{ y }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- Month Filter -->
    <mat-form-field appearance="outline" class="col-2">
      <mat-label>Select Month</mat-label>
      <mat-select [(ngModel)]="selectedMonth">
        <mat-option [value]="null">All Months</mat-option>
        <mat-option *ngFor="let m of months" [value]="m.value">
          {{ m.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="col-3">
      <!-- Filter Button -->
      <button mat-mini-fab color="accent" class="mr-2" (click)="filterMonthlyData()">
        <mat-icon>search</mat-icon>
      </button>
      <!-- Clear -->
      <button mat-mini-fab color="warn" (click)="clearFilters()" matTooltip="Clear">
        <mat-icon>clear</mat-icon>
      </button>
    </div>

  </div>

  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Counselling Centre Log</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input">
          <i class="material-icons search-icon">search</i>
        </label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box" #input>
      </li>
    </ul>

    <ul class="header-buttons mr-2">
      <li>
        <button mat-mini-fab color="primary"
                (click)="AddCenterCounsellingLog()"
                permission="Counselling Center Log"
                [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>
    </ul>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">

    <ng-container matColumnDef="no">
      <th mat-header-cell *matHeaderCellDef>No</th>
      <td mat-cell *matCellDef="let row; let i = index;">
        {{ i + 1 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef>Centre Name</th>
      <td mat-cell *matCellDef="let row">
        {{ row.centreName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef>Child Name</th>
      <td mat-cell *matCellDef="let row">
        {{ row.childName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="session">
      <th mat-header-cell *matHeaderCellDef>Session</th>
      <td mat-cell *matCellDef="let row">
        {{ row.session }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let row">
        {{ row.type }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let row">
        {{ row.date | date:'dd/MM/yyyy' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="remark">
      <th mat-header-cell *matHeaderCellDef>Remark</th>
      <td mat-cell *matCellDef="let row" style="max-width: 300px;">
        <div [class.remark-collapsed]="!expandedRemarks[row.id]"
             [class.remark-expanded]="expandedRemarks[row.id]">
      <span *ngIf="!expandedRemarks[row.id]">
        {{ getTruncatedRemark(row.remark) }}
      </span>
          <span *ngIf="expandedRemarks[row.id]">
        {{ row.remark }}
      </span>
        </div>
        <button mat-button color="primary"
                *ngIf="isRemarkLong(row.remark)"
                (click)="toggleRemark(row.id)"
                style="font-size: 12px; padding: 0; min-width: auto;">
          {{ expandedRemarks[row.id] ? 'Show Less' : 'Show More' }}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="sessionDocumented">
      <th mat-header-cell *matHeaderCellDef>Session Documented</th>
      <td mat-cell *matCellDef="let row">
        {{ row.sessionDocumented }}
      </td>
    </ng-container>

    <!-- ACTION COLUMN -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef> Action</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="primary" (click)="openEdit(element)"
                permission="Counselling Center Log"
                [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]">
          <mat-icon>edit</mat-icon>
        </button>

        <button mat-icon-button color="warn" (click)="deleteDoc(element.id)"
                permission="Counselling Center Log"
                [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td
        class="mat-cell text-center py-4"
        [attr.colspan]="displayedColumns.length">
        No data available
      </td>
    </tr>
  </table>


  <mat-paginator [pageSizeOptions]="[25,50,10,200,400]" showFirstLastButtons></mat-paginator>
</div>
